import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';

const Div = styled.div`
  padding-left: 24px;
  ${mobile_xl(css`
    padding-left: 0;
    margin-bottom: 65px;
  `)}
`;
export { Div };
